<script>
    import Button from "$lib/atoms/Button.svelte";
    import ContainerBgImageHeadlineAndSubtitle from "$lib/components/Container_bg_image_headline_and_subtitle.svelte";
    import ContainerBgImageHeadlineAndSubtitleSuggested from "$lib/components/Container_bg_image_headline_and_subtitle_suggested.svelte";
    import "../../../../../app.css";
    import { t } from '$lib/i18n.js';
</script>

<section>
    <div class="header">
        <div class="titles">
            <h2 class="accent">{$t('routes.owner.protections.top_subheadline_accent')}</h2>
            <h2>{$t('routes.owner.protections.title')}</h2>
            <Button reload={true} label={$t('routes.owner.protections.cta')} href='/assicurazione'/>
        </div>
        <div class="reale">
            <p>{$t('routes.owner.protections.insured_by')}</p>
            <img src="https://assets.auting.it/images/reale-mutua/colored.png" alt="Reale Assicurazioni Logo" />
        </div>
    </div>

    <div class="options">
        <ContainerBgImageHeadlineAndSubtitle 
            headline={$t('routes.owner.protections.cols.1.headline')}
            topheadline={$t('routes.owner.protections.cols.1.top_subheadline_accent')}
            backgroundColor="var(--on-surface)"
            image="https://assets.auting.it/images/photos/risks.svg"
        />
        <ContainerBgImageHeadlineAndSubtitle 
            headline={$t('routes.owner.protections.cols.2.headline')}
            subheadline={$t('routes.owner.protections.cols.2.subheadline')}
            image="https://assets.auting.it/images/photos/call-center.webp"
        />
    </div>
</section>

<style>
    section {
        padding-top: 140px;
        padding-bottom: 140px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 48px;
    }

    h2 {
        margin: 0;
        padding: 0;
        text-align: start;
        font-family: var(--font-body);
        font-size: 56px;
    }

    h2.accent {
        color: var(--water-green);
        font-family: var(--font-heading);
        font-size: 32px;
        letter-spacing: -1px;
    }

    .options {
        max-width: var(--max-width);
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        gap: 16px;
    }

    .header {
        display: flex;
        flex-direction: row;
        align-items: flex-end;
        justify-content: space-between;
        width: 100%;
        max-width: var(--max-width);
        padding: 0 16px;
        box-sizing: border-box;
    }

    .titles {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        gap: 16px;
        width: 100%;
    }

    .reale {
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        align-items: flex-end;
        width: 100%;
    }

    .reale img {
        width: 200px;
    }

    @media (max-width: 768px) {
        section {
            margin-left: 16px;
            margin-right: 16px;
        }
        .options {
            flex-direction: column;
            align-items: center;
        }

        h2 {
            font-size: 40px;
            letter-spacing: -2px;
            text-align: center;
        }

        h2.accent {
            font-size: 28px;
            margin-bottom: 0px;
        }

        .header {
            flex-direction: column;
            align-items: center;
            justify-content: center;
            text-align: center;
            gap: 32px;
        }

        .titles {
            align-items: center;
            text-align: center;
        }

        .reale {
            align-items: center;
            text-align: center;
        }
    }
</style>
